/** 资源管理相关Api */

import { _, AppAuthApi, App, defineAppApi, storage } from '@zto/zpage'
import { REQUEST_CODES } from '../consts'
import { favUtil, saveAppAuthData, getAppAuthData } from '../utils'
import { RbacRoleScopeTypeName } from '../../../../src/config/enums'
import { resourcesToPcMenuTree } from '../../../../src/utils/resourceTree'

export default defineAppApi<AppAuthApi>((app: App) => {
  return {
    baseUrl: app.env.apiUrl,

    methods: api => {
      return {
        /** 获取token */
        async getToken(code: string) {
          const res = await app.apis.scmApi.getToken(code)
          return res
        },

        /** 刷新token */
        async exchangeToken(refreshToken: string) {
          const res = await app.apis.scmApi.exchangeToken(refreshToken)
          return res
        },

        async login(model: any) {
          let params = {
            tenantId: model.tenantId, // 租户
            mobile: model.mobile,
            password: model.password
          }

          let res = await app.request({
            api: '/base_user/admin/auth/login',
            data: params
          })

          /** 保存accessToken */
          app.token.setAccessToken(res.token)
          storage.local.set('userCode', res.userCode)
          storage.local.set('userName', res.userName)
          // app.token.setAccessToken([res.access_token || '', res.user_id || '', res.openid || ''].join())
        },

        /** 获取用户信息 */
        async getUserInfo() {
          const isPortal = false

          app.isPortal = isPortal

          const authData = getAppAuthData(true)

          let portalRoleCode = ''
          let deptCode = authData?.deptCode || ''
          let positionCode = authData?.positionCode || ''
          let basicInfo: any = {}
          let pcMenuTree: any[] = []
          let permissionCodes: any[] = []

          // 原开天获取菜单
          const userCode = storage.local.get('userCode')
          const userName = storage.local.get('userName')
          const userRes: any = await api.request({
            api: '/base_user/admin/account/resources',
            reqCode: REQUEST_CODES.AUTH_GET_USER_INFO,
            data: { userCode }
          })

          // const userRes: any = {
          //   pcMenuTree: [
          //     {
          //       code: 'P1744621821597',
          //       parentCode: 'P1640599134458',
          //       icon: '',
          //       name: '营销柜',
          //       id: 6833,
          //       sort: '0',
          //       type: 'MENU',
          //       value: 'tuda.base',
          //       url: '',
          //       children: [
          //         {
          //           code: 'P1766472892633',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '商品管理',
          //           id: 1,
          //           sort: '0',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.goods',
          //           url: '/cabinet/goods'
          //         },
          //         {
          //           code: 'P1766472892634',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '供应商管理',
          //           id: 2,
          //           sort: '10',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.supplier',
          //           url: '/cabinet/supplier'
          //         },
          //         {
          //           code: 'P1766472892638',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '模版管理',
          //           id: 6,
          //           sort: '20',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.template',
          //           url: '/cabinet/template'
          //         },
          //         {
          //           code: 'P1766472892635',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '推广管理',
          //           id: 3,
          //           sort: '20',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.promotion',
          //           url: '/cabinet/promotion'
          //         },
          //         {
          //           code: 'P1766472892637',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '发货单管理',
          //           id: 4,
          //           sort: '30',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.shipment',
          //           url: '/cabinet/shipment'
          //         },
          //         {
          //           code: 'P1766472892636',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '订单管理',
          //           id: 5,
          //           sort: '40',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.order',
          //           url: '/cabinet/order'
          //
          //         },
          //         {
          //           code: 'P1766472892639',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '门店配置管理',
          //           id: 7,
          //           sort: '40',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.shop',
          //           url: '/cabinet/shop'
          //         },
          //         {
          //           code: 'P1766472892640',
          //           children: [],
          //           parentCode: 'P1744621821597',
          //           icon: '',
          //           name: '商品销售报表',
          //           id: 8,
          //           sort: '45',
          //           type: 'MENU',
          //           value: 'tuda.cabinet.productSalesReport',
          //           url: '/cabinet/product-sales-report'
          //         }
          //       ]
          //     },
          //     {
          //       code: 'P1744621821598',
          //       parentCode: 'P1640599134458',
          //       icon: '',
          //       name: '无人车',
          //       id: 6833,
          //       sort: '0',
          //       type: 'MENU',
          //       value: 'tuda.car',
          //       url: '',
          //       children: [
          //         {
          //           code: 'P1766472892600',
          //           children: [],
          //           parentCode: 'P1744621821598',
          //           icon: '',
          //           name: '分账管理',
          //           id: 1,
          //           sort: '0',
          //           type: 'MENU',
          //           value: 'tuda.car.splitbillconfiguration',
          //           url: '/car/splitbillconfiguration'
          //         },
          //         {
          //           code: 'P1766472892601',
          //           children: [],
          //           parentCode: 'P1744621821599',
          //           icon: '',
          //           name: '扣款',
          //           id: 1,
          //           sort: '0',
          //           type: 'MENU',
          //           value: 'tuda.car.deduction',
          //           url: '/car/deduction'
          //         }
          //       ]
          //     },
          //     {
          //       code: 'P_SYS_ROOT_001',
          //       parentCode: 'P1640599134458',
          //       icon: '',
          //       name: '系统',
          //       id: 9000,
          //       sort: '3',
          //       type: 'MENU',
          //       value: 'tuda.system',
          //       url: '',
          //       children: [
          //         {
          //           code: 'P_SYS_RES_001',
          //           children: [],
          //           parentCode: 'P_SYS_ROOT_001',
          //           icon: '',
          //           name: '资源管理',
          //           id: 9001,
          //           sort: '0',
          //           type: 'MENU',
          //           value: 'tuda.system.resource',
          //           url: '/system/resource'
          //         },
          //         {
          //           code: 'P_SYS_ROLE_001',
          //           children: [],
          //           parentCode: 'P_SYS_ROOT_001',
          //           icon: '',
          //           name: '角色管理',
          //           id: 9002,
          //           sort: '10',
          //           type: 'MENU',
          //           value: 'tuda.system.role',
          //           url: '/system/role'
          //         },
          //         {
          //           code: 'P_SYS_ACC_001',
          //           children: [],
          //           parentCode: 'P_SYS_ROOT_001',
          //           icon: '',
          //           name: '账号管理',
          //           id: 9003,
          //           sort: '20',
          //           type: 'MENU',
          //           value: 'tuda.system.account',
          //           url: '/system/account'
          //         }
          //       ]
          //     }
          //   ],
          //   accountCode: userCode,
          //   realName: userName,
          //   account: userName
          // }

          basicInfo = _.omit(userRes, ['resources', 'permissionCodes'])
          basicInfo.nickname = userName + '-' + userRes.roleNames?.join(',')
          basicInfo.username = userName

          pcMenuTree = resourcesToPcMenuTree(userRes.resources || [])
          permissionCodes = userRes.permissionCodes || []

          const menus = pcMenuTree
            .map((it: any) => formatScmMenu(it))
            .filter((it: any) => !!it)
            .filter((it: any) => it.path !== '/welcome') // 过滤welcome页面（特殊）永远不会出现在菜单中！！！
          console.info('🚀 ~ file:auth method:getUserInfo line:288 ----- menus', pcMenuTree)

          saveAppAuthData({
            deptCode: basicInfo.deptCode,
            iamToken: app.token.getAccessToken(),
            portalRoleCode,
            positionCode
          })

          const favorite = { favs: [] }

          return {
            ...basicInfo,
            menus,
            permissions: permissionCodes,
            data: { basic: basicInfo, favorite }
          }
        },

        /** 获取用户岗位 */
        async getUserPositions() {
          // const res: any = await api.fetch({ url: 'base.currUserDeptPositionList' })
          // return res
          return []
        },

        /** 确认用户已读 组织/岗位切换提醒 */
        async confirmUserPositionRead() {
          await api.fetch({ url: 'base.readDeptPosition' })
        },

        /**
         * 用户切换组织/岗位
         * @param params
         */
        async changeUserPosition(params: any) {
          await api.fetch({
            url: 'base.updateDeptPosition',
            data: params
          })
        },

        /**
         * 检查用户权限
         * @param code 权限编码
         */
        checkPermission(codes: string | string[]) {
          if (!codes) return true

          codes = Array.isArray(codes) ? codes : [codes]

          const permissions = app.stores.userStore.permissions || []

          const flag = codes.some(code => permissions.includes(code))
          return flag
        }
      }
    }
  }
})

function formatScmMenu(scmMenu: any) {
  // 移除重复的开天菜单
  if (['kt.welcome', 'boss.welcome'].includes(scmMenu.value)) return null
  if (['/welcome', 'welcome'].includes(scmMenu.url)) return null

  const order = parseInt(scmMenu.sort)

  const menu: any = {
    menuId: scmMenu.code,
    parentMenuId: scmMenu.parentCode,
    keyName: scmMenu.value || scmMenu.code,
    menuName: scmMenu.name,
    name: scmMenu.name,
    path: scmMenu.url,
    order: isNaN(order) ? 0 : order,
    bizId: scmMenu.bizId
  }

  if (scmMenu.children?.length) {
    menu.children = scmMenu.children
      .map((it: any) => {
        return formatScmMenu(it)
      })
      .filter((it: any) => !!it)
      .sort(menuOrder)
  }

  return menu
}

function menuOrder(a: any, b: any) {
  return a?.order - b?.order
}
